import { withNamespaces } from 'react-i18next';
import {
    Card,
    CardBody,
} from 'reactstrap';

import CheckList from './CheckList';

const CheckListsCard = ({
    bid,
}) => {
    if (!bid.attentionItems.length && !bid.otherChecks.length) {
        return null;
    }

    return (
        <Card className="bg-white">
            <CardBody>
                <CheckList
                    items={bid.attentionItems}
                    title={bid.highlightsTitle}
                />
                <CheckList
                    items={bid.otherChecks}
                    title={bid.attentionItems.length ? 'Other checks' : bid.highlightsTitle}
                />
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(
    CheckListsCard
);
